



























import Vue from 'vue'
import Component from 'vue-class-component'

import '@/assets/pcc-upload-status/complete.svg?sprite'
import '@/assets/pcc-upload-status/failed.svg?sprite'
import '@/assets/pcc-upload-status/not-uploaded.svg?sprite'
import '@/assets/reply.svg?sprite'
// import '@/assets/three-dots.svg?sprite'
// import '@/assets/alert-warning.svg?sprite'
import '@/assets/paper.svg?sprite'
import '@/assets/comment.svg?sprite' // 1 use
import '@/assets/curve-arrow-right.svg?sprite' // 1 use
// import '@/assets/empty-settings.svg?sprite'
// import '@/assets/reschedule.svg?sprite' // 1 use
// import '@/assets/task-icon.svg?sprite'
// import '@/assets/ti-date.svg?sprite'
// import '@/assets/ti-phone.svg?sprite'
// import '@/assets/ti-bag.svg?sprite'
// import '@/assets/ti-home.svg?sprite'
// import '@/assets/ti-mail.svg?sprite'
// import '@/assets/ti-cellphone.svg?sprite'
// import '@/assets/ti-email.svg?sprite'
// import '@/assets/ti-left.svg?sprite'
// import '@/assets/ti-card.svg?sprite'
// import '@/assets/ti-right.svg?sprite'
// import '@/assets/ti-back.svg?sprite'
// import '@/assets/ti-nouser.svg?sprite'
// import '@/assets/ti-lock.svg?sprite'
import '@/assets/ti-review.svg?sprite'
// import '@/assets/ti-residents.svg?sprite'
import '@/assets/logo.svg?sprite'
// import '@/assets/enter.svg?sprite'
// import '@/assets/turn.svg?sprite'
// import '@/assets/search.svg?sprite'
// import '@/assets/date.svg?sprite'
// import '@/assets/left.svg?sprite'
// import '@/assets/right.svg?sprite'
import '@/assets/caret.svg?sprite'
// import '@/assets/export.svg?sprite'
// import '@/assets/checkbox.svg?sprite'
import '@/assets/close.svg?sprite'
import '@/assets/logo_white.svg?sprite'
// import '@/assets/eye.svg?sprite'
// import '@/assets/eye-orange.svg?sprite'
// import '@/assets/arrow-down.svg?sprite'
// import '@/assets/check-item.svg?sprite' // 1 use
// import '@/assets/calendar.svg' // questions

// import '@/assets/update.svg?sprite'
// import '@/assets/mail.svg?sprite'
// import '@/assets/back.svg?sprite'
import '@/assets/review-statements.svg?sprite' // 1 use
// import '@/assets/trash.svg?sprite'
// import '@/assets/bill.svg?sprite' // 1 use
// import '@/assets/due.svg?sprite'
// import '@/assets/avatar.svg?sprite'
// import '@/assets/mail-tag.svg?sprite'
import '@/assets/dollar.svg?sprite'
// import '@/assets/warning.svg?sprite'
import '@/assets/exclude.svg?sprite'
// import '@/assets/check.svg?sprite'
// import '@/assets/arrow-forward.svg?sprite'
// import '@/assets/phone.svg?sprite' // 1 use
// import '@/assets/mobile-phone.svg?sprite'
// import '@/assets/track.svg?sprite'
import '@/assets/humb.svg?sprite'
import '@/assets/pin-comment.svg?sprite'
// import '@/assets/location.svg?sprite'
// import '@/assets/home.svg?sprite'
import '@/assets/visa.svg?sprite'
import '@/assets/mastercard.svg?sprite'
import '@/assets/discover.svg?sprite'
import '@/assets/amex.svg?sprite'
import '@/assets/visawhite.svg?sprite'
import '@/assets/mastercardwhite.svg?sprite'
import '@/assets/discoverwhite.svg?sprite'
import '@/assets/amexwhite.svg?sprite'
// import '@/assets/banks/bank_america.svg?sprite'
// import '@/assets/print.svg?sprite'
// import '@/assets/payment-one-time.svg?sprite'
// import '@/assets/payment-schedule.svg?sprite'
// import '@/assets/payment-autopay.svg?sprite'
import '@/assets/time-morning.svg?sprite'
import '@/assets/time-midday.svg?sprite'
import '@/assets/time-evening.svg?sprite'
// import '@/assets/creditcard-visa.svg?sprite'
// import '@/assets/creditcard-visa-selected.svg?sprite'
// import '@/assets/edit-gray.svg?sprite'
// import '@/assets/edit-orange.svg?sprite' // 1 use
// import '@/assets/check-orange.svg?sprite'
// import '@/assets/bank-boa.svg?sprite'
// import '@/assets/drag.svg?sprite'
// import '@/assets/ring.svg?sprite'
import '@/assets/loading.svg?sprite' // 1 use
import '@/assets/lock.svg?sprite' // 1 use
// import '@/assets/arrow-left.svg?sprite'
// import '@/assets/arrow-right.svg?sprite'
// import '@/assets/orange-checkmark.svg?sprite' // 1 use
// import '@/assets/triangle.svg?sprite' // 1 use
// import '@/assets/info.svg?sprite'
import '@/assets/chrome-icon.svg?sprite'
import '@/assets/firefox-icon.svg?sprite'
import '@/assets/opera-icon.svg?sprite'
import '@/assets/empty-logo.svg?sprite' // 1 use
// import '@/assets/nav.svg?sprite'
import '@/assets/arrow-right-xs-orange.svg?sprite'
import '@/assets/arrow-left-xs-orange.svg?sprite'
// import '@/assets/settings.svg?sprite'
// import '@/assets/message.svg?sprite'
import '@/assets/plus-simple.svg?sprite'
import '@/assets/minus-simple.svg?sprite'
// import '@/assets/upload.svg?sprite'
// import '@/assets/trash-fill.svg?sprite'
// import '@/assets/paper-plane.svg?sprite'
import '@/assets/bed.svg?sprite' // 1 use
// import '@/assets/work.svg?sprite' // 1 use
// import '@/assets/home2.svg?sprite' // 1 use
// import '@/assets/email2.svg?sprite' // to discuss
// import '@/assets/email2_bold.svg?sprite' // to discuss
// import '@/assets/envelope.svg?sprite'
// import '@/assets/mobile.svg?sprite' // to discuss

// import '@/assets/info-square.svg?sprite'

// import '@/assets/time-circle.svg?sprite'
// import '@/assets/chat.svg?sprite'
// import '@/assets/task.svg?sprite'

// new icons
import '@/assets/check.svg?sprite'
import '@/assets/new-icons/dollar.svg?sprite'
import '@/assets/new-icons/pop-out.svg?sprite'
import '@/assets/new-icons/star.svg?sprite'
import '@/assets/new-icons/download.svg?sprite'
import '@/assets/new-icons/edit.svg?sprite'
import '@/assets/new-icons/update.svg?sprite'
import '@/assets/new-icons/settings.svg?sprite'
import '@/assets/new-icons/enter.svg?sprite'
import '@/assets/new-icons/three-dots.svg?sprite'
import '@/assets/new-icons/clock.svg?sprite'
import '@/assets/new-icons/chart.svg?sprite'
import '@/assets/new-icons/credit-card.svg?sprite'
import '@/assets/new-icons/ring.svg?sprite'

import '@/assets/new-icons/add.svg?sprite'
import '@/assets/new-icons/advansed-search.svg?sprite'
import '@/assets/new-icons/aging.svg?sprite'
import '@/assets/new-icons/arrow-bottom.svg?sprite'
import '@/assets/new-icons/arrow-left.svg?sprite'
import '@/assets/new-icons/arrow-right.svg?sprite'
import '@/assets/new-icons/arrow-top.svg?sprite'
import '@/assets/new-icons/buildings.svg?sprite'
import '@/assets/new-icons/burger.svg?sprite'
import '@/assets/new-icons/calendar.svg?sprite'
import '@/assets/new-icons/checkbox.svg?sprite'
import '@/assets/new-icons/chevron-down.svg?sprite'
import '@/assets/new-icons/chevron-left.svg?sprite'
import '@/assets/new-icons/chevron-right.svg?sprite'
import '@/assets/new-icons/chevron-up.svg?sprite'
import '@/assets/new-icons/comment.svg?sprite'
import '@/assets/new-icons/contacts.svg?sprite'
import '@/assets/new-icons/dashboard.svg?sprite'
import '@/assets/new-icons/delivery.svg?sprite'
import '@/assets/new-icons/turn.svg?sprite'
import '@/assets/new-icons/email.svg?sprite'
import '@/assets/new-icons/envelope.svg?sprite'
import '@/assets/new-icons/error.svg?sprite'
import '@/assets/new-icons/expand.svg?sprite'
import '@/assets/new-icons/folder.svg?sprite'
import '@/assets/new-icons/hide.svg?sprite'
import '@/assets/new-icons/home.svg?sprite'
import '@/assets/new-icons/info.svg?sprite'
import '@/assets/new-icons/link.svg?sprite'
import '@/assets/new-icons/mobile.svg?sprite'
import '@/assets/new-icons/money.svg?sprite'
import '@/assets/new-icons/path.svg?sprite'
import '@/assets/new-icons/phone.svg?sprite'
import '@/assets/new-icons/pin.svg?sprite'
import '@/assets/new-icons/pin-comment.svg?sprite'
import '@/assets/new-icons/plus.svg?sprite'
import '@/assets/new-icons/print.svg?sprite'
import '@/assets/new-icons/refund.svg?sprite'
import '@/assets/new-icons/trash.svg?sprite'
import '@/assets/new-icons/search.svg?sprite'
import '@/assets/new-icons/send.svg?sprite'
import '@/assets/new-icons/sending.svg?sprite'
import '@/assets/new-icons/sheild.svg?sprite'
import '@/assets/new-icons/show.svg?sprite'
import '@/assets/new-icons/site.svg?sprite'
import '@/assets/new-icons/stats.svg?sprite'
import '@/assets/new-icons/task.svg?sprite'
import '@/assets/new-icons/template.svg?sprite'
import '@/assets/new-icons/upload.svg?sprite'
import '@/assets/new-icons/user.svg?sprite'
import '@/assets/new-icons/users.svg?sprite'
import '@/assets/new-icons/warning.svg?sprite'
import '@/assets/new-icons/web.svg?sprite'
import '@/assets/new-icons/work.svg?sprite'
import '@/assets/new-icons/party.svg?sprite'
import '@/assets/new-icons/credentials.svg?sprite'
import '@/assets/new-icons/sync-list.svg?sprite'
import '@/assets/new-icons/success-checkbox.svg?sprite'

@Component({
  name: 'Icon',
  props: {
    icon: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    size: {
      default: 16
    },
    colored: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    tooltip: Object,
    specialWidth: Number,
    testid: String
  }
})
export default class Icon extends Vue {
  handleClick (e: any): void {
    if (this.$props.disabled) {
      e.stopPropagation()
    } else {
      this.$emit('click', e)
    }
  }
}
